import { c as _c } from "react/compiler-runtime";
// https://github.com/shadcn-ui/ui/discussions/1694#discussioncomment-11729367
import type { VariantProps } from 'class-variance-authority';
import { cva } from 'class-variance-authority';
import { createFixedArray } from 'foxact/create-fixed-array';
import * as React from 'react';
import { cn } from '@/lib/utils';
const spinnerVariants = cva('relative inline-block aspect-square', {
  variants: {
    variant: {
      default: '[&>div]:bg-foreground',
      primary: '[&>div]:bg-primary',
      secondary: '[&>div]:bg-secondary',
      destructive: '[&>div]:bg-destructive',
      muted: '[&>div]:bg-muted-foreground'
    },
    size: {
      sm: 'size-4',
      default: 'size-5',
      lg: 'size-8'
    }
  },
  defaultVariants: {
    variant: 'default',
    size: 'default'
  }
});
export interface SpinnerProps extends React.ComponentProps<'div'>, Omit<VariantProps<typeof spinnerVariants>, 'size'> {
  className?: string;
  size?: VariantProps<typeof spinnerVariants>['size'] | number;
}
function Spinner(t0) {
  const $ = _c(11);
  const {
    className,
    variant,
    size: t1
  } = t0;
  const size = t1 === undefined ? "default" : t1;
  let t2;
  if ($[0] !== className || $[1] !== size || $[2] !== variant) {
    t2 = cn(typeof size === "string" ? spinnerVariants({
      variant,
      size
    }) : spinnerVariants({
      variant
    }), className);
    $[0] = className;
    $[1] = size;
    $[2] = variant;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== size) {
    t3 = typeof size === "number" ? {
      width: size,
      height: size
    } : undefined;
    $[4] = size;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = createFixedArray(8).map(_temp);
    t5 = <span className="sr-only">Loading...</span>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t4 = $[6];
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t2 || $[9] !== t3) {
    t6 = <div role="status" aria-label="Loading" className={t2} style={t3}>{t4}{t5}</div>;
    $[8] = t2;
    $[9] = t3;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}
function _temp(i) {
  return <div key={i} className="absolute top-[4.4%] left-[46.5%] h-[28%] w-[9%] origin-[center_170%] animate-spinner rounded-full opacity-10 will-change-transform" style={{
    transform: `rotate(${i * 45}deg)`,
    animationDelay: `${i * 0.125}s`
  }} aria-hidden="true" />;
}
export { Spinner };